const actions = {
  CREATE_USER: 'CREATE_USER',
  CREATE_USER_ENDED: 'CREATE_USER_ENDED',
  SEARCH_USERS: 'SEARCH_USERS',
  SEARCH_USERS_ENDED: 'SEARCH_USERS_ENDED',
  GET_ACCOUNT_FILTER_FORM_ROLES: 'GET_ACCOUNT_FILTER_FORM_ROLES',
  GET_ACCOUNT_FILTER_FORM_ROLES_ENDED: 'GET_ACCOUNT_FILTER_FORM_ROLES_ENDED',
  GET_ACCOUNT_CREATION_FORM_ROLES: 'GET_ACCOUNT_CREATION_FORM_ROLES',
  GET_ACCOUNT_CREATION_FORM_ROLES_ENDED: 'GET_ACCOUNT_CREATION_FORM_ROLES_ENDED',
  FIND_USER: 'FIND_USER',
  FIND_USER_ENDED: 'FIND_USER_ENDED',
  UPDATE_USER: 'UPDATE_USER',
  UPDATE_USER_ENDED: 'UPDATE_USER_ENDED',
  UPDATE_USER_STATUS: 'UPDATE_USER_STATUS',
  UPDATE_USER_STATUS_ENDED: 'UPDATE_USER_STATUS_ENDED',
  UPDATE_USER_PROFILE: 'UPDATE_USER_PROFILE',
  UPDATE_USER_PROFILE_ENDED: 'UPDATE_USER_PROFILE_ENDED',
  UPDATE_USER_PASSWORD: 'UPDATE_USER_PASSWORD',
  UPDATE_USER_PASSWORD_ENDED: 'UPDATE_USER_PASSWORD_ENDED',
  RESET_USER_PASSWORD: 'RESET_USER_PASSWORD',
  RESET_USER_PASSWORD_ENDED: 'RESET_USER_PASSWORD_ENDED',
  CREATE_ROLE: 'CREATE_ROLE',
  CREATE_ROLE_ENDED: 'CREATE_ROLE_ENDED',
  SEARCH_ROLES: 'SEARCH_ROLES',
  SEARCH_ROLES_ENDED: 'SEARCH_ROLES_ENDED',
  FIND_ROLE: 'FIND_ROLE',
  FIND_ROLE_ENDED: 'FIND_ROLE_ENDED',
  GET_USER_ROLES: 'GET_USER_ROLES',
  GET_USER_ROLES_ENDED: 'GET_USER_ROLES_ENDED',
  UPDATE_ROLE: 'UPDATE_ROLE',
  UPDATE_ROLE_ENDED: 'UPDATE_ROLE_ENDED',
  DELETE_ROLES: 'DELETE_ROLES',
  DELETE_ROLES_ENDED: 'DELETE_ROLES_ENDED',
  GET_PERMISSIONS: 'GET_PERMISSIONS',
  GET_PERMISSIONS_ENDED: 'GET_PERMISSIONS_ENDED',
  GET_USERS_INFO: 'GET_USERS_INFO',
  GET_USERS_INFO_ENDED: 'GET_USERS_INFO_ENDED',
};

export default actions;
